<template>
  <div class="warn_wrap">
    <img src="@/assets/about_us/warn/warn.png" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.warn_wrap {
  background: #0E1010;

  img {
    width: 50%;
    display: block;
    margin: 0 auto;
  }
}
</style>